import { useState, useRef, useEffect } from "react"

import { LoginButton, LoginWrapper, LoginFormMain } from "./Atom"
import styles from "../../../styles/Login.module.css"
import {
  Box,
  CircularProgress,
  FormControlLabel,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material"
import Checkbox from "@mui/material/Checkbox"
import ArrowForwardIcon from "@mui/icons-material/ArrowForward"
import { useNavigate } from "react-router"
import { CheckBox, Visibility, VisibilityOff } from "@mui/icons-material"
import TermsOfService from "../../components/Modal/TermsOfService"
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"
import { setIsTermsChecked } from "../../redux/slices/appSlice"
import { colors } from "../../../styles/commonStyles"

type ChangePasswordProps = {
  loading: boolean
  type: "create" | "forgot" | "change"
  email: string
  password: string
  setNewPassword: any
  setConfirmNewPassword: any
  newPasswordError: any
  confirmNewPasswordError: any
  handleChangePassword: any
}

const ChangePassword = (props: ChangePasswordProps) => {
  const dispatch = useDispatch()
  const [open, setOpen] = useState(false)
  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)
  const {
    loading,
    type,
    email,
    password,
    setNewPassword,
    setConfirmNewPassword,
    newPasswordError,
    confirmNewPasswordError,
    handleChangePassword,
  } = props
  const [showNewPassword, setShowNewPassword] = useState(false)
  const [showConfirmPassword, setShowConfirmPassword] = useState(false)
  const navigate = useNavigate()

  if (type == "create") {
    if (!(email && password)) {
      navigate("/auth")
    }
  }

  if (type == "forgot") {
    if (!email) {
      navigate("/auth")
    }
  }

  const inputRefs: any = useRef([])

  const handleKeyPress = (index: any) => {
    const nextIndex = index + 1
    inputRefs.current[nextIndex]?.focus()
  }

  const handleClickEnter = (e: any, index: any) => {
    if (e.key === "Enter") {
      e.preventDefault()

      handleKeyPress(index)
    }
  }

  const handleClickSubmit = (e: any) => {
    if (e.key === "Enter") {
      e.preventDefault()

      handleChangePassword()
    }
  }

  const isChecked = useSelector((state: any) => {
    return state.app.isTermsChecked
  })

  return (
    <>
      <LoginWrapper>
        <h4 className={styles.LoginText}>
          {type == "create"
            ? `NEW PASSWORD`
            : type == "forgot"
            ? `RESET PASSWORD`
            : ``}
        </h4>
        <LoginFormMain>
          <TextField
            sx={{
              marginTop: "0px",
            }}
            type={showNewPassword ? "text" : "password"}
            error={newPasswordError ? true : false}
            helperText={newPasswordError}
            required
            onChange={(e) => setNewPassword(e.target.value)}
            onKeyDown={(e) => handleClickEnter(e, 0)}
            autoFocus
            label="Password"
            className={styles.TextInput}
            autoComplete="off"
            inputRef={(ref) => (inputRefs.current[0] = ref)}
            InputProps={{
              endAdornment: (
                <InputAdornment
                  position="end"
                  onClick={() => setShowNewPassword(!showNewPassword)}
                  sx={{ cursor: "pointer" }}
                >
                  {showNewPassword ? <VisibilityOff /> : <Visibility />}
                </InputAdornment>
              ),
            }}
          />

          <TextField
            sx={{
              marginTop: "15px",
            }}
            type={showConfirmPassword ? "text" : "password"}
            error={confirmNewPasswordError ? true : false}
            helperText={confirmNewPasswordError}
            required
            onChange={(e) => setConfirmNewPassword(e.target.value)}
            onKeyDown={(e) => handleClickSubmit(e)}
            label="Confirm Password"
            className={styles.TextInput}
            autoComplete="off"
            inputRef={(ref) => (inputRefs.current[1] = ref)}
            InputProps={{
              endAdornment: (
                <InputAdornment
                  position="end"
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  sx={{ cursor: "pointer" }}
                >
                  {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                </InputAdornment>
              ),
            }}
          />
        </LoginFormMain>
        <Box>
          <Checkbox
            sx={{}}
            //disabled={isChecked}
            checked={isChecked}
            onChange={() => handleOpen()}
          />
          <span>
            I Agree to the &nbsp;
            <span className={styles.termsText} onClick={handleOpen}>
              Terms of Service
            </span>
          </span>
        </Box>

        <LoginButton
          disabled={!isChecked}
          variant="contained"
          onClick={() => handleChangePassword()}
          endIcon={
            loading ? (
              <CircularProgress size={20} sx={{ color: "#FFFFFF" }} />
            ) : (
              <ArrowForwardIcon />
            )
          }
        >
          <Typography
            style={{ textTransform: "none" }}
            fontSize={16}
            fontWeight={500}
          >
            {type == "create"
              ? `CREATE PASSWORD`
              : type == "forgot"
              ? `RESET PASSWORD`
              : ``}
          </Typography>
        </LoginButton>
      </LoginWrapper>
      <TermsOfService
        open={open}
        setOpen={setOpen}
        handleOpen={handleOpen}
        handleClose={handleClose}
      />
    </>
  )
}

export default ChangePassword
